// extracted by mini-css-extract-plugin
export default {"growingBars":"LoadinIndicator_growingBars__1V0py","bar":"LoadinIndicator_bar__knUdE","grow":"LoadinIndicator_grow__nkxU7"};